import React, { useState } from 'react';

const SongSelector = ({ onSongSelect, onURLSubmit }) => {
  const [youtubeURL, setYouTubeURL] = useState('');

  const predefinedSongs = [
    { title: "Le Chant des Partisans", id: "HLib4lIbdks" }, // Exemple d'ID YouTube
    { title: "Aux paysans de France", id: "VSFBcSuij3o" },
    { title: "Voix française et québécoise - E. Macron et J. Trudeau", id: "M4GKD1L_uGg" },
    { title: "L’accent marseillais - À 2 ! ", id: "A2r0tBjxlVI"},
  ];

  const handleSongSelection = (e) => {
    const selectedSong = predefinedSongs.find(song => song.id === e.target.value);
    if (selectedSong) {
      onSongSelect(selectedSong.id);
    }
  };

  const handleURLChange = (e) => {
    setYouTubeURL(e.target.value);
  };

  const handleURLSubmit = () => {
    onURLSubmit(youtubeURL);
  };

  return (
    <div>
      <div className="song-selection">
        
        <select id="predefined-songs" onChange={handleSongSelection}>
          <option value="">Choix d’un extrait vidéo</option>
          {predefinedSongs.map(song => (
            <option key={song.id} value={song.id}>{song.title}</option>
          ))}
        </select>
      </div>

      <div className="url-input">
        <label htmlFor="youtube-url">Ou amusez-vous en trouvant un lien de Youtube de votre choix ! </label>
        <br/>
        <input
          type="text"
          id="youtube-url"
          value={youtubeURL}
          onChange={handleURLChange}
          placeholder="https://www.youtube.com/watch?v=..."
        />
        <button onClick={handleURLSubmit}>▶️</button>
      </div>
    </div>
  );
};

export default SongSelector;
